export function getSsoLoginUrl({ baseUrl, returnTo, accountsUrl }) {
	const loginUrl = accountsUrl
		? new URL('/login', accountsUrl)
		: new URL(`${baseUrl}/user/sso-login`);

	loginUrl.searchParams.set('return_to', returnTo);
	if (accountsUrl) {
		// Preserve the parameters forwarded by the backend SSO route.
		loginUrl.searchParams.set('from', 'dashboard');
		loginUrl.searchParams.set('url', new URL(baseUrl).origin);
	}

	return loginUrl.toString();
}
